import { useEffect, useRef, useState } from 'react';
import { useApi } from '../../hooks/useApi';
import { driftBody, driftErrorText, driftUrl } from './softwarePolicy';

// One machine's software compared with its account's policy, and its known CVEs, both made by cma/softwaredrift from
// the machine's installed-programs result (`data`). The Software tab and the Software policy tab share this one answer.
// state is 'idle' (no result to send yet), 'loading', 'ok' (result) or 'error' (error).
export function useSoftwareDrift(account, deviceId, data) {
  const jApi = useApi();
  const apiRef = useRef(jApi);
  apiRef.current = jApi;
  const [drift, setDrift] = useState({ state: 'idle' });

  useEffect(() => {
    let cancelled = false;
    if (!data) {
      setDrift({ state: 'idle' });
      return undefined;
    }
    if (!account) {
      setDrift({ state: 'error', error: 'The address has no account.' });
      return undefined;
    }
    setDrift({ state: 'loading' });
    apiRef.current.request('POST', driftUrl(account, deviceId), driftBody(data))
      .then((response) => { if (!cancelled) setDrift({ state: 'ok', result: response.data }); })
      .catch((ex) => {
        if (cancelled) return;
        console.error('Software policy comparison failed:', ex);
        setDrift({ state: 'error', error: driftErrorText(ex) });
      });
    return () => { cancelled = true; };
  }, [account, deviceId, data]);

  return drift;
}

export default useSoftwareDrift;
